import { CSSProperties } from 'react';
import { css } from 'styled-components';

import type { Styled } from '../types/common.types';

export type BaseOverflowProps = {
  overflow: CSSProperties['overflow'];
  overflowX: CSSProperties['overflowX'];
  overflowY: CSSProperties['overflowY'];
};

export type OverflowProps = Partial<BaseOverflowProps>;

export type StyledOverflowProps = Styled<OverflowProps>;

/**
 * Styles that can map overflow props prefixed with `$` to an adequate CSS property
 *
 * @example
 * const Test = styled.div<StyledOverflowProps>`
 *   ${overflowStyles}
 * `
 */
export const overflowStyles = css<StyledOverflowProps>(
  ({ $overflow, $overflowX, $overflowY }) => ({
    overflow: $overflow,
    overflowX: $overflowX,
    overflowY: $overflowY,
  }),
);

export const extractOverflowProps = <T extends OverflowProps>(
  props: T,
): BaseOverflowProps => {
  const { overflow, overflowX, overflowY } = props;

  const extracted: BaseOverflowProps = { overflow, overflowX, overflowY };

  return extracted;
};
